module.exports = __webpack_public_path__ + "img/linkedin_snippet.e9b797fe.svg";